import "./../login/login.css";
import "./otp.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card } from "react-bootstrap/";
import Logo from "./../../assets/logo.svg";
import { TextField, Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import { baseUrl } from "../../network/constants/constants";
import AppConstants from "../AppConstants"; // Assuming AppConstants is defined
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Otp({ onOtpVerified }) {
  const location = useLocation();
  const phone = location.state?.data?.phone;
  const [otp, setOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const navigate = useNavigate();

  // Safety check: Redirect if phone number is missing
  useEffect(() => {
    if (!phone) {
      navigate("/login", { replace: true });
    }
  }, [phone, navigate]);

  const handleOTP = (event) => {
    setOTP(event.target.value);
  };

  const validateOTP = (otp) => {
    const regex = /^\d{6}$/;
    setOtpError(!regex.test(otp));
    return regex.test(otp);
  };

  const PostOTP = () => {
    if (!validateOTP(otp)) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setLoading(true);

    const payload = { phone, otp };

    axios
      .post(baseUrl + "auth/auth/validate/", payload)
      .then((response) => {
        localStorage.setItem(AppConstants.JWT, response.data["token"]);
        // Set OTP verified status
        localStorage.setItem("isOtpVerified", "true");

        // Notify App.jsx to update its state
        window.dispatchEvent(new Event("authUpdate"));

        toast.success("OTP verified successfully!");

        if (onOtpVerified) onOtpVerified();

        // Use navigate for smooth routing
        navigate("/home", { replace: true });
      })
      .catch((error) => {
        console.error(error);
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "OTP verification failed! Try again.";
        toast.error(errorMsg);
        setOtpError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!phone) return null; 

  return (
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img src={Logo} className="logo" alt="logo" />
          <div className="business-name">Onescribe Super Admin Panel</div>
        </div>
        <Card className="login-card card mt-5 rounded-4">
          <div className="login-title">OTP Verification</div>

          <TextField
            id="otp"
            className="mt-4"
            label="Enter OTP"
            variant="outlined"
            size="small"
            value={otp}
            onChange={handleOTP}
            error={otpError}
            helperText={otpError ? "Invalid OTP Number" : ""}
          />

          <Button
            variant="contained"
            className="login-btn mt-5 mb-3"
            onClick={PostOTP}
            disabled={loading}
          >
            Submit
          </Button>

          <div className="not-number">
            {phone}
            <div onClick={() => navigate("/login", { replace: true })}>
              Not your Number? Click to Go Back
            </div>
          </div>

          <div className="spiner-container">
            <TailSpin
              className="mt-5"
              height="30"
              width="30"
              radius="1"
              color="#ffbe00"
              ariaLabel="loading"
              visible={loading}
            />
          </div>
        </Card>
      </div>

      <a href="tel:+919481815122" className="contact">
        ⓘ Contact Us
      </a>

      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
    </section>
  );
}

export default Otp;
